// Configuración de Obra › Clima de una cámara: umbrales de "día apto" y reporte mensual por mail.
// Se guarda en el backend (/api/clima/:feedId/config → Firestore climaConfigs). Si el backend no responde
// (por ejemplo, todavía no está publicado) se usa una copia local para que la pantalla funcione igual.
import axios from 'axios';
import R from './reglasClima';

const BASE = process.env.REACT_APP_ALERTAS_API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081';
const api = axios.create({ baseURL: `${BASE.replace(/\/$/, '')}/api/clima`, timeout: 12000 });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authLisualToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const lsKey = (feedId) => 'clima:cfg:' + feedId;
const local = (feedId) => { try { return JSON.parse(localStorage.getItem(lsKey(feedId)) || 'null'); } catch (e) { return null; } };
const guardarLocal = (feedId, v) => { try { localStorage.setItem(lsKey(feedId), JSON.stringify(v)); } catch (e) { /* */ } };

const completar = (x) => ({
  umbrales: R.sanearUmbrales((x && x.umbrales) || {}),
  reporteMensual: R.sanearReporte((x && x.reporteMensual) || {}),
});

export async function leerConfig(feedId) {
  if (!feedId) return { ...completar(local('x')), origen: 'local' };
  try {
    const r = await api.get(`/${encodeURIComponent(feedId)}/config`);
    guardarLocal(feedId, r.data);
    return { ...completar(r.data), origen: 'servidor' };
  } catch (e) {
    return { ...completar(local(feedId)), origen: 'local' };
  }
}

export async function guardarConfig(feedId, patch) {
  try {
    const r = await api.put(`/${encodeURIComponent(feedId)}/config`, patch);
    guardarLocal(feedId, r.data);
    return { ...completar(r.data), origen: 'servidor' };
  } catch (e) {
    if (e?.response?.status === 400) throw new Error(e.response.data?.message || 'Revisá los datos');
    const prev = local(feedId) || {};
    const v = completar({ ...prev, ...patch, umbrales: { ...(prev.umbrales || {}), ...(patch.umbrales || {}) } });
    guardarLocal(feedId, v);
    return { ...v, origen: 'local' };
  }
}
